import { Form, FormRow, FormCol, TextControl, SearchIcon, TertiarySubmitButton, TertiaryButton } from 'ia-react-core';
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import CollapseTile from './CollapseTile';
import { StyledActionBar, StyledButton } from './SearchDocuments.styles';
import DocumentPeriodRow from './DocumentPeriodRow';
import DocumentTypeRow from './DocumentTypeRow';
import DocumentProductRow from './DocumentProductRow';
import useHandleSubmitForm from './hooks/useHandleSubmitForm';
import useTextControlDefaultValue from './hooks/useTextControlDefaultValue';
import { resetDocumentsForm } from '../../../../actions/Documents.actions';
import Constants from '../../../../Constants';

export interface SearchDocumentsProps { }

const SearchDocuments: FC<SearchDocumentsProps> = () => {
  const { t } = useTranslation('Documents');
  const dispatch = useDispatch();
  const handleResetForm = () => dispatch(resetDocumentsForm());
  const handleSubmitForm = useHandleSubmitForm();
  const { search } = useLocation();

  useEffect(() => {
    const defaultParameters = [
      Constants.DefaultDocumentTypesParam,
      Constants.DefaultContractsParam,
      Constants.DefaultPeriodParam,
      Constants.DefaultKeywordParam];
    if (defaultParameters.filter((x) => new URLSearchParams(search).has(x)).length > 0) {
      handleSubmitForm();
    }
  }, [search, handleSubmitForm]);

  const textControlDefaultValue = useTextControlDefaultValue(Constants.DefaultKeywordParam);

  return (
    <CollapseTile title={t('search')}>
      <Form
        valuesSrc="searchCriteria"
        name="documentSearchForm"
        defaultCol={12}
        onSubmit={handleSubmitForm}
      >
        <FormRow>
          <FormCol label={t('keyword')}>
            <TextControl name="keyword" defaultValue={textControlDefaultValue} />
          </FormCol>
        </FormRow>
        <DocumentPeriodRow />
        <DocumentTypeRow />
        <DocumentProductRow />
        <StyledActionBar data-analytics-disabled>
          <TertiarySubmitButton RightIcon={SearchIcon}>{t('search')}
          </TertiarySubmitButton>
          <StyledButton>
            <TertiaryButton
              outline
              onClick={handleResetForm}
            >{t('reset')}
            </TertiaryButton>
          </StyledButton>
        </StyledActionBar>
      </Form>
    </CollapseTile>
  );
};

export default SearchDocuments;
